import Swiper, {Navigation, Autoplay} from "swiper";
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Autoplay]);
window.Swiper = Swiper;

import Fuse from "fuse.js"

window.Fuse = Fuse

import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

Alpine.plugin(focus)
Alpine.plugin(intersect)
Alpine.plugin(persist)
Alpine.plugin(collapse)
window.Alpine = Alpine

Alpine.start()
